<template>
    <v-app style="background-image: linear-gradient(-150deg, #FFFFFF, #FFFFFF);">
      <v-breadcrumbs large :items="breadcrumbs">
        <template v-slot:divider>
          <v-icon color="#64f5a9" size="25">keyboard_arrow_right</v-icon>
        </template>
      </v-breadcrumbs>
  
      <v-card class="form-container elevation-1">
        <v-card-title>
          <span class="title">
            <v-icon color="#2d93ea" size="25">book</v-icon>&nbsp;Booking Details&nbsp;
          </span>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-container>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <p>Tour Name<br/>{{ detail.tourName }}</p>
              </v-flex>
              <v-flex xs12 md6>
                <p>Travel Date<br/>{{ detail.travelDate }}</p>
              </v-flex>
              <v-flex xs12 md12>
                <p>Email ID<br/>{{ detail.email }}</p>
              </v-flex>
              <v-flex xs12 md3>
                <p>Booken On<br/>{{ formatDate(detail.bookedOn) }}</p>
              </v-flex>
              <v-flex xs12 md3>
                <p>Person Name<br/>{{ detail.name }}</p>
              </v-flex>
              <v-flex xs12 md3>
                <p>Sex<br/>{{ detail.sex }}</p>
              </v-flex>
              <v-flex xs12 md3>
                <p>Age<br/>{{ detail.age }}</p>
              </v-flex>
              <v-flex xs12 md2 style="padding-top: 15px;">MODE OF JOURNEY</v-flex>
              <v-flex xs12 md5 style="margin-top: 10px;">
                <p>UP<br/>{{ detail.up }}</p>
              </v-flex>
              <v-flex xs12 md5 style="margin-top: 10px;">
                <p>DN<br/>{{ detail.dn }}</p>
              </v-flex>

              <v-flex xs12 md6>
                OFFICE ADDRESS<br/>
                <p>Address: {{ detail.officeAddress }}<br/>PH No: {{ detail.officePhno }}</p>
              </v-flex>
              <v-flex xs12 md6>
                RESIDENTIAL ADDRESS<br/>
                <p>Address: {{ detail.residentialAddress }}<br/>PH No: {{ detail.residentialPhno }}</p>
              </v-flex>
            </v-layout>
        </v-container>
        
        <div v-for="(item, index) of enquiries" :key="index">
            <p v-if="item.name!=''" style="padding: 10px;border-radius: 15px;border:1px solid">
            <span style="color: grey;">Name: </span>{{ item.name }}  <span style="color: grey;">Sex: </span>{{ item.sex }}  <span style="color: grey;">Age: </span>{{ item.age }}
            </p>
        </div>
        
      </v-card>
    </v-app>
  </template>
  
  <script>
  import config from "./../../config.json";
  export default {
    data() {
      return {
        breadcrumbs: [
          {
            text: "Dashboard",
            disabled: false,
            to: "/_"
          },
          {
            text: "Bookings",
            disabled: false,
            to: "/bookings"
          },
          {
            text: "Booking Details",
            disabled: true,
            to: "/bookings"
          }
        ],

        detail:null,
        
        enquiries: [],
        search: "",
        enquiriesTableHeader: [
          { text: "#",
          align: 'left',
            sortable: false, value: "index" },
          { text: "Name.", value: "name" },
          { text: "Sex", value: "sex" },
          { text: "Age", value: "age" }
        ]
      };
    },
  
    methods: {
      getData() {
        this.axios
      .get(config.API + `Book/${this.$route.params.id}`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        console.log(res.data);
        this.detail=res.data;
        this.enquiries = res.data.list;
      })
      .catch(err => {
        console.log(err.message);
      });
      },
     // :rows-per-page-items="[10,15,20]"
      
  
      onView(item) {
        this.$router.push(`booking-detail/${item.id}`);
      },
      formatDate(dateString) {
        // Convert dateString to a Date object
        const date = new Date(dateString);
        
        // Format the date using toLocaleDateString()
        return date.toDateString("dd/MM/yyyy");
    }
    },
  
    mounted() {
      this.getData();
      this.$Progress.start();
    }
  };
  </script>
  <style lang="css" scoped>
  .bckclr {
    -webkit-text-fill-color:cornflowerblue
  }
  .txt_dec:hover {
      text-decoration: none !important;
  }
  </style>